import React, { Fragment } from 'react';
import Typography from '@mui/material/Typography';
import Minutes from '../minutes-select';
import Hour from '../hour-select';
import LabelBox from '../labelBox';

const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

const YearlyCron = ({ value, onChange, translate: translateFn }) => {
    const updateCron = (changes) => {
        const nextValue = [...value];
        Object.entries(changes).forEach(([index, fieldValue]) => {
            nextValue[index] = fieldValue;
        });
        onChange(nextValue);
    };

    const onDayChange = (e) => {
        const day = e.target.value;

        if ((parseInt(day, 10) > 0 && parseInt(day, 10) <= 31)) {
            updateCron({
                0: '0',
                3: day,
                4: value[4] === '*' || value[4] === '1/1' ? '1' : value[4],
                5: '?',
                6: '*'
            });
        }
    };

    const onMonthChange = (e) => {
        updateCron({
            0: '0',
            3: value[3] === '?' || value[3] === '1/1' || value[3] === '*' ? '1' : value[3],
            4: e.target.value,
            5: '?',
            6: '*'
        });
    };

    const onAtHourChange = (e) => {
        updateCron({
            0: '0',
            2: `${e.target.value}`
        });
    };

    const onAtMinuteChange = (e) => {
        updateCron({
            0: '0',
            1: `${e.target.value}`
        });
    };

    return (
        <Fragment>
            <LabelBox variant="content">
                <span>{translateFn('On day')} </span>
                <input
                    style={{ marginRight: '4px' }}
                    type="number"
                    min="1"
                    max="31"
                    value={value[3] === '?' ? '' : value[3]}
                    onChange={onDayChange}
                />
                <span>{translateFn('of')} </span>
                <select
                    style={{ marginLeft: '4px' }}
                    value={value[4] === '*' || value[4] === '1/1' ? '1' : value[4]}
                    onChange={onMonthChange}
                >
                    {months.map((month, index) => (
                        <option key={month} value={`${index + 1}`}>
                            {translateFn(month)}
                        </option>
                    ))}
                </select>
                <span> {translateFn('every year')}</span>
            </LabelBox>
            <LabelBox variant="content">
                <Typography sx={{ marginRight: '4px' }} variant="body1" gutterBottom>
                    <span>{translateFn('Start time')} </span>
                    <Hour onChange={onAtHourChange} value={value[2]} />
                    <Minutes onChange={onAtMinuteChange} value={value[1]} />
                </Typography>
            </LabelBox>
        </Fragment>
    );
};

YearlyCron.defaultProps = {
    onChange: (nextValue) => {}
};

YearlyCron.muiName = 'YearlyCron';

export default YearlyCron;